import React from 'react';
import { Link } from 'Elements';

const MarketingButton = (props) => <Link className="btn btn-outline-primary" {...props} outline>{props.children}</Link>;

export default MarketingButton;